module.exports = __webpack_public_path__ + "static/media/riosul.9908ffb6.webp";